
import { Motd } from "@/models/motd";
import { MotdService } from "@/services/motd-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			motd: new Motd()
		};
	},
	computed: {
		languages():string[]{
			return ["nl-be", "en", "fr"];
		}
	},
	methods: {
		async saveMotd(){
			if (this.motd.id == 0) {
				await MotdService.createMotd(this.motd);
			}else{
				await MotdService.updateMotd(this.motd);
			}
			this.$router.push("/motd");
		},
		async sendToCurrentlyActiveUsers(){
			await MotdService.publishToOnlineUsers(this.motd.translations);
			this.$router.push("/motd");
		}
	},
	async mounted() {

		let idStr = this.$route.params["id"];
		if (!idStr) return;
		let id = parseInt(idStr) || 0;
		if (id == 0) return;
		this.motd = await MotdService.getItem(id);

	}
});
